import withPrefix from '@/utils/withPrefix'

export default [
  ...withPrefix('/brands/:brandId', [
    {
      path: '/sites',
      name: 'sites',
      component: () => import('./views/SitesIndex'),
      meta: {
        auth: true
      }
    },
    {
      path: '/sites/new',
      name: 'sitesNew',
      component: () => import('./views/SitesCreate'),
      meta: {
        auth: true
      }
    }
  ]),
  ...withPrefix('/brands/:brandId/sites/:siteId', [
    {
      path: '/site-settings',
      name: 'settings',
      component: () => import('./views/SitesEdit'),
      meta: {
        auth: true
      }
    }
  ])
]
